import { getHeaderElement } from "./getHeaderElement";
export var headerAwareSmoothScroll = function headerAwareSmoothScroll(anchorId) {
  var _headerElement$getBou;
  var element = document.getElementById(anchorId);
  var headerElement = getHeaderElement();
  if (!element) return;
  window.scrollTo({
    top: element.getBoundingClientRect().top - ((headerElement === null || headerElement === void 0 ? void 0 : (_headerElement$getBou = headerElement.getBoundingClientRect()) === null || _headerElement$getBou === void 0 ? void 0 : _headerElement$getBou.height) || 0),
    behavior: 'smooth'
  });
};